import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
                      Hi Everyone, We are <span className="purple">21 Interior Studio </span>
            from <span className="purple"> Vadodra, India.</span>
            <br />
            <br />
            We bring together a passionate team of architects, designers, and engineers dedicated to delivering exceptional design solutions.
            <br />
            <br />
            What We Are <strong className="purple">Providing </strong>
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> 2D Detailed Drawings
            </li>
            <li className="about-activity">
              <ImPointRight /> 3D Renders   
            </li>
            <li className="about-activity">
              <ImPointRight /> Designing
            </li>
            <li className="about-activity">
              <ImPointRight /> Turnkey Projects
            </li>
          </ul>

        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
